/**
 * Simulación de calificación de leads (no persiste en BD).
 * Matriz: Origen, Integridad, Intención, Velocidad, Recurrencia.
 */

export const SECCIONES_CALIFICACION_LEADS = [
  {
    id: 'origen',
    titulo: 'Origen',
    maxPuntos: 100,
    exclusivo: true,
    criterios: [
      { id: 'origen_sucursal', etiqueta: 'Sucursal', puntos: 100 },
      { id: 'origen_recomendacion', etiqueta: 'Recomendación', puntos: 100 },
      { id: 'origen_llamada', etiqueta: 'Llamada', puntos: 80 },
      { id: 'origen_google_web', etiqueta: 'Google (Web)', puntos: 60 },
      { id: 'origen_meta_ads', etiqueta: 'Meta Ads', puntos: 50 },
      { id: 'origen_influencer', etiqueta: 'Influencer', puntos: 40 },
      { id: 'origen_whatsapp_directo_mkt', etiqueta: 'WhatsApp Directo (Mkt)', puntos: 45 },
      { id: 'origen_meta_inbox', etiqueta: 'Meta / Inbox', puntos: 40 },
      { id: 'origen_meta_comentario', etiqueta: 'Meta / Comentario', puntos: 10 },
      { id: 'origen_desconocido', etiqueta: 'Desconocido', puntos: 10 },
    ],
  },
  {
    id: 'integridad',
    titulo: 'Integridad',
    maxPuntos: 30,
    exclusivo: true,
    criterios: [
      { id: 'integridad_completo', etiqueta: 'Datos completos (4 preguntas bot)', puntos: 30 },
      { id: 'integridad_incompleto', etiqueta: 'Datos incompletos', puntos: 0 },
    ],
  },
  {
    id: 'intencion',
    titulo: 'Intención',
    maxPuntos: 40,
    exclusivo: true,
    criterios: [
      { id: 'intencion_5_palabras', etiqueta: 'Respuesta >= 5 palabras', puntos: 40 },
      { id: 'intencion_menor_5_palabras', etiqueta: 'Respuesta con menos de 5 palabras', puntos: 0 },
    ],
  },
  {
    id: 'velocidad',
    titulo: 'Velocidad',
    maxPuntos: 20,
    exclusivo: true,
    criterios: [
      { id: 'velocidad_llenado_menor_igual_3_min', etiqueta: 'Llenado <= 3 min', puntos: 20 },
      { id: 'velocidad_llenado_mayor_3_min', etiqueta: 'Llenado > 3 min', puntos: 5 },
    ],
  },
  {
    id: 'recurrencia',
    titulo: 'Recurrencia',
    maxPuntos: 15,
    exclusivo: true,
    criterios: [
      { id: 'recurrencia_usuario_nuevo', etiqueta: 'Usuario nuevo', puntos: 15 },
      { id: 'recurrencia_usuario_anterior', etiqueta: 'Usuario anterior', puntos: 5 },
    ],
  },
]

export const TOTAL_CASOS_CALIFICACION_LEADS = 50

export const NIVELES_CALIFICACION_LEADS = [
  {
    id: 1,
    slug: 'baja',
    nombre: 'Baja',
    intentCategory: 'BAJA',
    descripcion: 'Prioridad mínima.',
    min: 0,
    max: 79,
    color: '#546E7A',
    chipColor: 'blue-grey',
  },
  {
    id: 2,
    slug: 'media',
    nombre: 'Media',
    intentCategory: 'MEDIA',
    descripcion: 'Prioridad estándar.',
    min: 80,
    max: 129,
    color: '#F57C00',
    chipColor: 'orange',
  },
  {
    id: 3,
    slug: 'alta',
    nombre: 'Alta',
    intentCategory: 'ALTA',
    descripcion: 'Prioridad inmediata.',
    min: 130,
    max: 205,
    color: '#2E7D32',
    chipColor: 'green',
  },
]

const ORIGENES_DEFAULT_ALTA = new Set([
  'sucursal',
  'recomendacion',
  'llamada',
  'whatsapp_directo_mkt',
  'meta_inbox',
  'meta_comentario',
])

const ORIGENES_DEFAULT_INTEGRIDAD = new Set()

const ORIGENES_CALIFICACION_CATALOGO = [
  { id: 'sucursal', label: 'Sucursal', puntos: 100 },
  { id: 'recomendacion', label: 'Recomendación', puntos: 100 },
  { id: 'llamada', label: 'Llamada', puntos: 80 },
  { id: 'whatsapp_directo_mkt', label: 'WhatsApp Directo (Mkt)', puntos: 45 },
  { id: 'google_web', label: 'Google (Web)', puntos: 60 },
  { id: 'meta_ads', label: 'Meta Ads', puntos: 50 },
  { id: 'meta_inbox', label: 'Meta / Inbox', puntos: 40 },
  { id: 'meta_comentario', label: 'Meta / Comentario', puntos: 10 },
  { id: 'desconocido', label: 'Desconocido', puntos: 10 },
  { id: 'influencer', label: 'Influencer', puntos: 40 },
]

const MATRIZ_POR_ORIGEN_CATALOGO = {
  sucursal: { integridad: [1], intencion: [1], velocidad: [1], recurrencia: [1, 0] },
  recomendacion: { integridad: [1], intencion: [1], velocidad: [1], recurrencia: [1, 0] },
  llamada: { integridad: [1], intencion: [1], velocidad: [1], recurrencia: [1, 0] },
  whatsapp_directo_mkt: { integridad: [1], intencion: [1], velocidad: [1], recurrencia: [1, 0] },
  google_web: { integridad: [1, 0], intencion: [1, 0], velocidad: [1, 0], recurrencia: [1, 0] },
  meta_ads: { integridad: [1, 0], intencion: [1, 0], velocidad: [1, 0], recurrencia: [1, 0] },
  meta_inbox: { integridad: [1], intencion: [1], velocidad: [1], recurrencia: [1, 0] },
  meta_comentario: { integridad: [1], intencion: [1], velocidad: [1], recurrencia: [1, 0] },
  desconocido: { integridad: [1, 0], intencion: [1, 0], velocidad: [1, 0], recurrencia: [1, 0] },
  influencer: { integridad: [0], intencion: [0], velocidad: [0], recurrencia: [1, 0] },
}

const BONUS_PUNTAJE_POR_COMBO = {
  'meta_ads|1|0|0': 10,
  'desconocido|1|1|0': 10,
}

let casoPorComboCache = null

function comboKey(origenId, integridad, intencion, velocidad, recurrencia) {
  return `${origenId}|${integridad}|${intencion}|${velocidad}|${recurrencia}`
}

function bonusComboKey(origenId, integridad, intencion, velocidad) {
  return `${origenId}|${integridad}|${intencion}|${velocidad}`
}

/** Con integridad incompleta (0) no aplica velocidad rápida (1). */
function esComboMatrizValido(integridad, intencion, velocidad) {
  if (!integridad && velocidad) return false
  return true
}

function normalizarComboTablaVerdad(integridad, intencion, velocidad) {
  if (!integridad && velocidad) {
    return { integridad, intencion, velocidad: 0 }
  }
  return { integridad, intencion, velocidad }
}

export function esCasoCalificacionValido(caso) {
  const n = Number(caso)
  return Number.isInteger(n) && n >= 1 && n <= TOTAL_CASOS_CALIFICACION_LEADS
}

export function esTelefonoLeadPruebaCalificacion(telefono) {
  const d = String(telefono || '').replace(/\D/g, '')
  if (d.length < 10) return false
  const last10 = d.slice(-10)
  const n = Number(last10)
  // telefonoPruebaPorCaso: 5500000000 + offset(0..49999) + caso(1..50)
  return n >= 5500000000 && n <= 5500100000
}

export function esProspectoLeadPruebaCalificacion(prospecto = {}) {
  const nota = String(prospecto.nota_inicial || '').toLowerCase()
  if (nota.includes('[prueba calificacion leads]')) return true
  if (nota.includes('lead de prueba')) return true
  if (nota.includes('whatsapp directo marketing')) return true

  const nombre = String(prospecto.nombre_completo || '').toUpperCase()
  if (nombre.includes('TWILIO COMPLETO') || nombre.includes('TWILIO INCOMPLETO')) return true
  if (nombre.includes('LEAD PRUEBA')) return true

  const refId = String(prospecto.referral_source_id || '')
  if (refId.indexOf('TEST_CASE_') === 0 || refId === 'TEST_META_ADS') return true

  const folio = String(prospecto.folio || '')
  if (folio.indexOf('SIM') === 0) return true

  return esTelefonoLeadPruebaCalificacion(prospecto.telefono)
}

const ORIGEN_ID_POR_CRITERIO = {
  origen_sucursal: 'sucursal',
  origen_recomendacion: 'recomendacion',
  origen_llamada: 'llamada',
  origen_google_web: 'google_web',
  origen_meta_ads: 'meta_ads',
  origen_influencer: 'influencer',
  origen_whatsapp_directo_mkt: 'whatsapp_directo_mkt',
  origen_meta_inbox: 'meta_inbox',
  origen_meta_comentario: 'meta_comentario',
  origen_desconocido: 'desconocido',
}

function obtenerCriterioActivoEnSeccion(prospecto, seccionId) {
  const seccion = (prospecto.desgloseSecciones || []).find((s) => s.id === seccionId)
  if (!seccion) return null
  return (seccion.criterios || []).find((c) => c.activo) || null
}

export function extraerComboDesdeProspecto(prospecto = {}) {
  const origenCrit = obtenerCriterioActivoEnSeccion(prospecto, 'origen')
  const integridadCrit = obtenerCriterioActivoEnSeccion(prospecto, 'integridad')
  const intencionCrit = obtenerCriterioActivoEnSeccion(prospecto, 'intencion')
  const velocidadCrit = obtenerCriterioActivoEnSeccion(prospecto, 'velocidad')
  const recurrenciaCrit = obtenerCriterioActivoEnSeccion(prospecto, 'recurrencia')

  if (origenCrit) {
    const origenId = ORIGEN_ID_POR_CRITERIO[origenCrit.id]
    if (!origenId) return null
    const integridad = integridadCrit && integridadCrit.id === 'integridad_completo' ? 1 : 0
    const intencion = intencionCrit && intencionCrit.id === 'intencion_5_palabras' ? 1 : 0
    const velocidad = velocidadCrit && velocidadCrit.id === 'velocidad_llenado_menor_igual_3_min' ? 1 : 0
    const recurrencia = recurrenciaCrit && recurrenciaCrit.id === 'recurrencia_usuario_nuevo' ? 1 : 0
    const combo = normalizarComboTablaVerdad(integridad, intencion, velocidad)
    return {
      origenId,
      integridad: combo.integridad,
      intencion: combo.intencion,
      velocidad: combo.velocidad,
      recurrencia,
    }
  }

  const v = prospecto.variables
  if (v && v.origen && v.origen.id) {
    const integridad = v.integridad && v.integridad.criterioId === 'integridad_completo' ? 1 : 0
    const intencion = v.intencion && v.intencion.criterioId === 'intencion_5_palabras' ? 1 : 0
    const velocidad = v.velocidad && v.velocidad.criterioId === 'velocidad_llenado_menor_igual_3_min' ? 1 : 0
    const recurrencia = v.recurrencia && v.recurrencia.criterioId === 'recurrencia_usuario_nuevo' ? 1 : 0
    const combo = normalizarComboTablaVerdad(integridad, intencion, velocidad)
    return {
      origenId: v.origen.id,
      integridad: combo.integridad,
      intencion: combo.intencion,
      velocidad: combo.velocidad,
      recurrencia,
    }
  }

  return null
}

export function prospectoCoincideConCasoCatalogo(prospecto, cat) {
  const combo = extraerComboDesdeProspecto(prospecto)
  if (!combo || !combo.origenId) return false
  return combo.origenId === cat.origenId
    && combo.integridad === Number(cat.integridad)
    && combo.intencion === Number(cat.intencion)
    && combo.velocidad === Number(cat.velocidad)
    && combo.recurrencia === Number(cat.recurrencia)
}

export function resolverCasoDesdeProspecto(prospecto = {}) {
  const combo = extraerComboDesdeProspecto(prospecto)
  if (!combo || !combo.origenId) return null
  const caso = resolverCasoTablaVerdad(
    combo.origenId,
    combo.integridad,
    combo.intencion,
    combo.velocidad,
    combo.recurrencia
  )
  return esCasoCalificacionValido(caso) ? caso : null
}

export function resolverPuntajeOficialDesdeProspecto(prospecto = {}) {
  const desglose = resolverDesglosePuntosOficialDesdeProspecto(prospecto)
  return desglose ? desglose.total : null
}

/** Pesos oficiales de la sábana por flag 1/0 (velocidad 0 = 5 pts, no 0). */
export const PUNTOS_OFICIALES_POR_FLAG = {
  integridad: { 0: 0, 1: 30 },
  intencion: { 0: 0, 1: 40 },
  velocidad: { 0: 5, 1: 20 },
  recurrencia: { 0: 5, 1: 15 },
}

export function puntosOficialesPorFlag(seccion, flag) {
  const tabla = PUNTOS_OFICIALES_POR_FLAG[seccion]
  return tabla ? tabla[flag ? 1 : 0] : 0
}

export function formatearFlagMatrizConPuntos(flag, puntos) {
  return `${flag} (${puntos})`
}

export function formatearCeldaMatrizCatalogo(integridad, intencion, velocidad, recurrencia, campo) {
  const flags = { integridad, intencion, velocidad, recurrencia }
  const flag = Number(flags[campo])
  return formatearFlagMatrizConPuntos(flag, puntosOficialesPorFlag(campo, flag))
}

export function formatearOrigenCatalogoConPuntos(origenId) {
  const origen = ORIGENES_CALIFICACION_CATALOGO.find((o) => o.id === origenId)
  return origen ? `${origen.label} (${origen.puntos})` : String(origenId || '')
}

export function formatearCeldaCatalogoMatriz(flag, campo) {
  const flagNum = Number(flag)
  return formatearFlagMatrizConPuntos(flagNum, puntosOficialesPorFlag(campo, flagNum))
}

export function formatearDesgloseSumaPuntos(partes, bonus = 0, total = null) {
  const sumandos = [
    Number(partes.origen || 0),
    Number(partes.integridad || 0),
    Number(partes.intencion || 0),
    Number(partes.velocidad || 0),
    Number(partes.recurrencia || 0),
  ]
  const expresion = sumandos.join('+')
  if (total === null || total === undefined) return expresion
  return `${expresion}=${Number(total)}`
}

export function resolverDesglosePuntosOficialDesdeProspecto(prospecto = {}) {
  const combo = extraerComboDesdeProspecto(prospecto)
  if (!combo || !combo.origenId) return null
  const origen = ORIGENES_CALIFICACION_CATALOGO.find((o) => o.id === combo.origenId)
  if (!origen) return null
  const integridad = puntosOficialesPorFlag('integridad', combo.integridad)
  const intencion = puntosOficialesPorFlag('intencion', combo.intencion)
  const velocidad = puntosOficialesPorFlag('velocidad', combo.velocidad)
  const recurrencia = puntosOficialesPorFlag('recurrencia', combo.recurrencia)
  const total = origen.puntos + integridad + intencion + velocidad + recurrencia
  const partes = {
    origen: origen.puntos,
    integridad,
    intencion,
    velocidad,
    recurrencia,
  }
  return {
    combo,
    origen: origen.puntos,
    origenLabel: origen.label,
    integridad,
    intencion,
    velocidad,
    recurrencia,
    bonus: 0,
    total,
    origenTexto: `${origen.label} (${origen.puntos})`,
    integridadTexto: formatearCeldaCatalogoMatriz(combo.integridad, 'integridad'),
    intencionTexto: formatearCeldaCatalogoMatriz(combo.intencion, 'intencion'),
    velocidadTexto: formatearCeldaCatalogoMatriz(combo.velocidad, 'velocidad'),
    recurrenciaTexto: formatearCeldaCatalogoMatriz(combo.recurrencia, 'recurrencia'),
    desgloseSuma: formatearDesgloseSumaPuntos(partes, 0, total),
  }
}

export function textoSumaPuntosOficial(desglose) {
  if (!desglose) return ''
  return [
    desglose.origen,
    desglose.integridad,
    desglose.intencion,
    desglose.velocidad,
    desglose.recurrencia,
  ].join('+')
}

function puntajeEsperadoPorCaso(origen, integridad, intencion, velocidad, recurrencia) {
  const velocidadPuntos = velocidad ? 20 : 5
  return origen.puntos
    + (integridad ? 30 : 0)
    + (intencion ? 40 : 0)
    + velocidadPuntos
    + (recurrencia ? 15 : 5)
}

function resolverCalificacionEsperada(puntaje) {
  if (puntaje >= 130) return 'Alta'
  if (puntaje >= 80) return 'Media'
  return 'Baja'
}

export { resolverCalificacionEsperada }

function buildCasoPorComboMap() {
  const map = new Map()
  let folio = 1

  ORIGENES_CALIFICACION_CATALOGO.forEach((origen) => {
    const matriz = MATRIZ_POR_ORIGEN_CATALOGO[origen.id]
    if (!matriz) return

    matriz.integridad.forEach((integridad) => {
      matriz.intencion.forEach((intencion) => {
        matriz.velocidad.forEach((velocidad) => {
          if (!esComboMatrizValido(integridad, intencion, velocidad)) return

          matriz.recurrencia.forEach((recurrencia) => {
            map.set(comboKey(origen.id, integridad, intencion, velocidad, recurrencia), folio)
            folio += 1
          })
        })
      })
    })
  })

  return map
}

function getCasoPorComboMap() {
  if (!casoPorComboCache) casoPorComboCache = buildCasoPorComboMap()
  return casoPorComboCache
}

export function resolverCasoTablaVerdad(origenId, integridad, intencion, velocidad, recurrencia) {
  const combo = normalizarComboTablaVerdad(integridad, intencion, velocidad)
  const caso = getCasoPorComboMap().get(comboKey(
    origenId,
    combo.integridad,
    combo.intencion,
    combo.velocidad,
    recurrencia
  ))
  return caso !== undefined && caso !== null ? caso : null
}

function bonusPuntajeNegocio(origenId, integridad, intencion, velocidad) {
  return BONUS_PUNTAJE_POR_COMBO[bonusComboKey(origenId, integridad, intencion, velocidad)] || 0
}

export function buildCasosCatalogo() {
  const filas = []

  ORIGENES_CALIFICACION_CATALOGO.forEach((origen) => {
    const matriz = MATRIZ_POR_ORIGEN_CATALOGO[origen.id]
    if (!matriz) return

    matriz.integridad.forEach((integridad) => {
      matriz.intencion.forEach((intencion) => {
        matriz.velocidad.forEach((velocidad) => {
          if (!esComboMatrizValido(integridad, intencion, velocidad)) return

          matriz.recurrencia.forEach((recurrencia) => {
            const caso = resolverCasoTablaVerdad(origen.id, integridad, intencion, velocidad, recurrencia)
            const puntajeEsperado = puntajeEsperadoPorCaso(origen, integridad, intencion, velocidad, recurrencia)
            filas.push({
              caso,
              origenId: origen.id,
              origenLabel: origen.label,
              origenPuntos: origen.puntos,
              integridad,
              intencion,
              velocidad,
              recurrencia,
              puntajeEsperado,
              calificacionEsperada: resolverCalificacionEsperada(puntajeEsperado),
            })
          })
        })
      })
    })
  })

  return filas.sort((a, b) => a.caso - b.caso)
}

export const PUNTAJE_MAXIMO_BRUTO = SECCIONES_CALIFICACION_LEADS.reduce(
  (total, seccion) => total + seccion.maxPuntos,
  0
)
export const PUNTAJE_MAXIMO_LEAD = PUNTAJE_MAXIMO_BRUTO

export const PUESTOS_SUCURSAL = [18, 19, 73]
export const PUESTOS_MERCADOTECNIA = [25, 48, 49, 54, 62, 74, 97, 101]

const ETIQUETAS_ORIGEN = {
  sucursal: 'Sucursal',
  recomendacion: 'Recomendación',
  llamada: 'Llamada',
  google_web: 'Google (Web)',
  meta_ads: 'Meta Ads',
  influencer: 'Influencer',
  whatsapp_directo_mkt: 'WhatsApp Directo (Mkt)',
  meta_inbox: 'Meta / Inbox',
  meta_comentario: 'Meta / Comentario',
  desconocido: 'Desconocido',
}

export function crearEstadoCriterios() {
  const estado = {}
  SECCIONES_CALIFICACION_LEADS.forEach((seccion) => {
    seccion.criterios.forEach((criterio) => {
      estado[criterio.id] = false
    })
  })
  return estado
}

export function textoTieneFacebook(valor) {
  const texto = String(valor || '').toLowerCase()
  return (
    texto.includes('fb.me') ||
    texto.includes('facebook.com') ||
    texto.includes('instagram.com') ||
    texto.includes('fb.com')
  )
}

export function textoTieneGoogle(valor) {
  const texto = String(valor || '').toLowerCase()
  return texto.includes('google') || texto.includes('gclid') || texto.includes('googleads')
}

function camposTextoOrigen(prospecto = {}) {
  return [
    prospecto.referral_source_url,
    prospecto.como_llego,
    prospecto.fuente,
    prospecto.detalle_fuente,
    prospecto.campania,
    prospecto.medio_contacto,
    prospecto.nota_inicial,
  ]
}

function origenDesdeCatalogoFuentes(prospecto = {}) {
  const fuente = normalizarTexto(prospecto.fuente)
  const detalle = normalizarTexto(prospecto.detalle_fuente)
  if (!fuente) return null

  if (fuente.includes('facebook') || fuente.includes('instagram')) {
    if (detalle.includes('comentario')) {
      return { id: 'meta_comentario', criterioId: 'origen_meta_comentario', puntos: 10, label: ETIQUETAS_ORIGEN.meta_comentario }
    }
    if (detalle.includes('mensaje')) {
      return { id: 'meta_inbox', criterioId: 'origen_meta_inbox', puntos: 40, label: ETIQUETAS_ORIGEN.meta_inbox }
    }
    return null
  }

  if (fuente.includes('recomendacion') || fuente.includes('recomendado')) {
    return { id: 'recomendacion', criterioId: 'origen_recomendacion', puntos: 100, label: ETIQUETAS_ORIGEN.recomendacion }
  }
  if (fuente.includes('llamada') || fuente.includes('telefono') || fuente.includes('call')) {
    return { id: 'llamada', criterioId: 'origen_llamada', puntos: 80, label: ETIQUETAS_ORIGEN.llamada }
  }
  if (fuente.includes('whatsapp')) {
    return { id: 'whatsapp_directo_mkt', criterioId: 'origen_whatsapp_directo_mkt', puntos: 45, label: ETIQUETAS_ORIGEN.whatsapp_directo_mkt }
  }
  if (fuente.includes('google ads') || fuente.includes('google my business')) {
    return { id: 'google_web', criterioId: 'origen_google_web', puntos: 60, label: ETIQUETAS_ORIGEN.google_web }
  }
  if (fuente.includes('visita a sucursal') || fuente.includes('fachada')) {
    return { id: 'sucursal', criterioId: 'origen_sucursal', puntos: 100, label: ETIQUETAS_ORIGEN.sucursal }
  }

  return null
}

function normalizarTexto(valor) {
  return String(valor || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
}

function contienePalabraWeb(texto = '') {
  const normalizado = normalizarTexto(texto)
  return /(^|[^a-z0-9])web([^a-z0-9]|$)/.test(normalizado)
}

/** Meta = prospecto con vínculo o referencia a Facebook */
export function esProspectoMeta(prospecto = {}) {
  return camposTextoOrigen(prospecto).some(textoTieneFacebook)
}

export function esProspectoGoogle(prospecto = {}) {
  return camposTextoOrigen(prospecto).some(textoTieneGoogle)
}

export function esProspectoMercadotecniaSucursal(prospecto = {}) {
  const idpuesto = Number(prospecto.idpuesto) || 0
  return PUESTOS_MERCADOTECNIA.includes(idpuesto) || PUESTOS_SUCURSAL.includes(idpuesto)
}

/** Sucursal = creado por recepción/vendedora en plantel (sin ser bot Twilio) */
export function esProspectoSucursal(prospecto = {}) {
  const nombre = String(prospecto.nombre_completo || '')
  if (nombre.match(/TWILIO/i)) return false
  if (esProspectoMeta(prospecto)) return false
  const idpuesto = Number(prospecto.idpuesto) || 0
  return PUESTOS_SUCURSAL.includes(idpuesto)
}

export function resolverOrigenProspecto(prospecto = {}) {
  const origen = resolverOrigenScoring(prospecto)
  if (origen.id === 'sucursal' || origen.id === 'recomendacion' || origen.id === 'llamada') return 'sucursal'
  if (origen.id === 'meta_inbox' || origen.id === 'meta_comentario' || origen.id === 'meta_ads') return 'meta'
  return 'otro'
}

function tieneReferralMeta(prospecto = {}) {
  if (prospecto.tiene_referral_meta === true || prospecto.tiene_referral_meta === 1) return true
  const meta = prospecto.referral_meta || {}
  return (
    String(meta.ReferralSourceId || prospecto.referral_source_id || '').trim() !== '' ||
    String(meta.ReferralSourceUrl || prospecto.referral_source_url || '').trim() !== '' ||
    String(meta.ReferralHeadline || '').trim() !== '' ||
    String(meta.ReferralBody || '').trim() !== '' ||
    String(meta.ReferralCtwaClid || '').trim() !== ''
  )
}

export function resolverOrigenScoring(prospecto = {}) {
  const campania = String(prospecto.campania || '').toLowerCase()
  const texto = camposTextoOrigen(prospecto).join(' ').toLowerCase()
  const primerMensajeLeadRaw = String(
    prospecto.primer_mensaje_lead || prospecto.primerMensajeLead || ''
  )
  const primerMensajeLead = normalizarTexto(primerMensajeLeadRaw)
  const fuente = normalizarTexto(prospecto.fuente)

  if (normalizarTexto(primerMensajeLead).includes('historia')) {
    return { id: 'influencer', criterioId: 'origen_influencer', puntos: 40, label: ETIQUETAS_ORIGEN.influencer }
  }
  if (contienePalabraWeb(primerMensajeLeadRaw)) {
    return { id: 'google_web', criterioId: 'origen_google_web', puntos: 60, label: ETIQUETAS_ORIGEN.google_web }
  }

  const origenCatalogo = origenDesdeCatalogoFuentes(prospecto)
  if (origenCatalogo) return origenCatalogo

  if (tieneReferralMeta(prospecto)) {
    const url = String(prospecto.referral_source_url || (prospecto.referral_meta || {}).ReferralSourceUrl || '')
    return {
      id: 'meta_ads',
      criterioId: 'origen_meta_ads',
      puntos: 50,
      label: ETIQUETAS_ORIGEN.meta_ads,
      detalle: url ? `Referral Twilio: ${url}` : 'Referral detectado en twilio_bd',
    }
  }

  // Catálogo explícito del lead (fuentes.fuente) — prioridad sobre puesto sucursal
  if (fuente) {
    if (fuente.includes('recomendacion') || fuente.includes('recomendado')) {
      return { id: 'recomendacion', criterioId: 'origen_recomendacion', puntos: 100, label: ETIQUETAS_ORIGEN.recomendacion }
    }
    if (fuente.includes('llamada') || fuente.includes('telefono') || fuente.includes('call')) {
      return { id: 'llamada', criterioId: 'origen_llamada', puntos: 80, label: ETIQUETAS_ORIGEN.llamada }
    }
    if (fuente.includes('whatsapp')) {
      return { id: 'whatsapp_directo_mkt', criterioId: 'origen_whatsapp_directo_mkt', puntos: 45, label: ETIQUETAS_ORIGEN.whatsapp_directo_mkt }
    }
    if (fuente.includes('meta ads') || fuente.includes('facebook ads') || fuente.includes('anuncio meta')) {
      return { id: 'meta_ads', criterioId: 'origen_meta_ads', puntos: 50, label: ETIQUETAS_ORIGEN.meta_ads }
    }
    if (fuente.includes('comentario') || fuente.includes('post')) {
      return { id: 'meta_comentario', criterioId: 'origen_meta_comentario', puntos: 10, label: ETIQUETAS_ORIGEN.meta_comentario }
    }
  }

  if (esProspectoSucursal(prospecto)) {
    return { id: 'sucursal', criterioId: 'origen_sucursal', puntos: 100, label: ETIQUETAS_ORIGEN.sucursal }
  }

  // Campaña es señal secundaria en Leads INBI/FAST.
  if (campania.includes('recomend')) {
    return { id: 'recomendacion', criterioId: 'origen_recomendacion', puntos: 100, label: ETIQUETAS_ORIGEN.recomendacion }
  }
  if (campania.includes('llamada') || campania.includes('call') || campania.includes('telefono')) {
    return { id: 'llamada', criterioId: 'origen_llamada', puntos: 80, label: ETIQUETAS_ORIGEN.llamada }
  }
  if (campania.includes('comentario') || campania.includes('comment') || campania.includes('post')) {
    return { id: 'meta_comentario', criterioId: 'origen_meta_comentario', puntos: 10, label: ETIQUETAS_ORIGEN.meta_comentario }
  }
  if (campania.includes('mensaje') || campania.includes('inbox') || campania.includes('dm')) {
    return { id: 'meta_inbox', criterioId: 'origen_meta_inbox', puntos: 40, label: ETIQUETAS_ORIGEN.meta_inbox }
  }
  if (campania.includes('meta ads') || campania.includes('facebook ads') || campania.includes('ads meta')) {
    return { id: 'meta_ads', criterioId: 'origen_meta_ads', puntos: 50, label: ETIQUETAS_ORIGEN.meta_ads }
  }
  if (campania.includes('whatsapp')) {
    return { id: 'whatsapp_directo_mkt', criterioId: 'origen_whatsapp_directo_mkt', puntos: 45, label: ETIQUETAS_ORIGEN.whatsapp_directo_mkt }
  }
  if (texto.includes('recomend')) {
    return { id: 'recomendacion', criterioId: 'origen_recomendacion', puntos: 100, label: ETIQUETAS_ORIGEN.recomendacion }
  }
  if (texto.includes('llamada') || texto.includes('telefono') || texto.includes('call')) {
    return { id: 'llamada', criterioId: 'origen_llamada', puntos: 80, label: ETIQUETAS_ORIGEN.llamada }
  }
  if (texto.includes('whatsapp') && PUESTOS_MERCADOTECNIA.includes(Number(prospecto.idpuesto) || 0)) {
    return {
      id: 'whatsapp_directo_mkt',
      criterioId: 'origen_whatsapp_directo_mkt',
      puntos: 45,
      label: ETIQUETAS_ORIGEN.whatsapp_directo_mkt,
    }
  }
  if (texto.includes('comentario') || texto.includes('comment') || texto.includes('post')) {
    return { id: 'meta_comentario', criterioId: 'origen_meta_comentario', puntos: 10, label: ETIQUETAS_ORIGEN.meta_comentario }
  }
  if (esProspectoMeta(prospecto)) {
    return { id: 'meta_inbox', criterioId: 'origen_meta_inbox', puntos: 40, label: ETIQUETAS_ORIGEN.meta_inbox }
  }
  return {
    id: 'desconocido',
    criterioId: 'origen_desconocido',
    puntos: 10,
    label: ETIQUETAS_ORIGEN.desconocido,
  }
}

function origenDefaultAltaCompleto(prospecto = {}) {
  const origen = resolverOrigenScoring(prospecto)
  return ORIGENES_DEFAULT_ALTA.has(origen.id)
}

function origenDefaultIntegridad(prospecto = {}) {
  const origen = resolverOrigenScoring(prospecto)
  return ORIGENES_DEFAULT_INTEGRIDAD.has(origen.id)
}

function tieneValor(valor) {
  return valor !== null && valor !== undefined && valor !== '' && valor !== 0 && valor !== '0'
}

export function esBotTwilio(prospecto = {}) {
  return String(prospecto.nombre_completo || '').toUpperCase().includes('TWILIO')
}

export function esBotCompleto(prospecto = {}) {
  const nombre = String(prospecto.nombre_completo || '').toUpperCase()
  if (nombre.includes('TWILIO INCOMPLETO')) return false
  if (nombre.includes('TWILIO COMPLETO')) return true
  if (prospecto.datos_bot_completo === true || prospecto.datos_bot_completo === 1) return true

  const preguntas = [
    prospecto.pregunta1,
    prospecto.pregunta2,
    prospecto.pregunta3,
    prospecto.pregunta4,
  ]
  return preguntas.every(tieneValor)
}

function contarPalabras(texto) {
  return String(texto || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean).length
}

function resolverIntegridad(prospecto = {}, origenScoring) {
  if (origenDefaultAltaCompleto(prospecto)) {
    return {
      criterioId: 'integridad_completo',
      puntos: 30,
      estado: 'cumple',
      detalle: `Regla ${origenScoring.label}: por default datos completos`,
    }
  }

  if (origenDefaultIntegridad(prospecto)) {
    return {
      criterioId: 'integridad_completo',
      puntos: 30,
      estado: 'cumple',
      detalle: `Regla ${origenScoring.label}: por default datos completos`,
    }
  }

  if (origenScoring.id === 'influencer') {
    return {
      criterioId: 'integridad_incompleto',
      puntos: 0,
      estado: 'no_cumple',
      detalle: 'Regla Influencer: se asume Twilio incompleto',
    }
  }

  if (esBotCompleto(prospecto)) {
    return {
      criterioId: 'integridad_completo',
      puntos: 30,
      estado: 'cumple',
      detalle: 'Bot completo o 4 preguntas respondidas',
    }
  }

  if (esBotTwilio(prospecto) || tieneValor(prospecto.pregunta1) || tieneValor(prospecto.pregunta2)) {
    return {
      criterioId: 'integridad_incompleto',
      puntos: 0,
      estado: 'no_cumple',
      detalle: 'Bot incompleto o faltan preguntas',
    }
  }

  return {
    criterioId: 'integridad_incompleto',
    puntos: 0,
    estado: 'sin_datos',
    detalle: 'Sin datos del bot',
  }
}

function resolverIntencion(prospecto = {}) {
  const origenScoring = resolverOrigenScoring(prospecto)
  if (origenDefaultAltaCompleto(prospecto)) {
    return {
      criterioId: 'intencion_5_palabras',
      puntos: 40,
      estado: 'cumple',
      detalle: `Regla ${origenScoring.label}: por default respuesta >= 5 palabras`,
    }
  }
  if (origenScoring.id === 'influencer') {
    return {
      criterioId: 'intencion_menor_5_palabras',
      puntos: 0,
      estado: 'no_cumple',
      detalle: 'Regla Influencer: se asume sin respuesta >= 5 palabras',
    }
  }

  const palabras = Number(
    prospecto.palabras_max_sin_primer_mensaje !== undefined
      ? prospecto.palabras_max_sin_primer_mensaje
      : prospecto.palabras_max_lead
  ) || 0

  if (palabras >= 5) {
    return {
      criterioId: 'intencion_5_palabras',
      puntos: 40,
      estado: 'cumple',
      detalle: `${palabras} palabras en mensajes del lead`,
    }
  }

  if (palabras > 0) {
    return {
      criterioId: 'intencion_menor_5_palabras',
      puntos: 0,
      estado: 'no_cumple',
      detalle: `${palabras} palabras en mensajes del lead`,
    }
  }

  return {
    criterioId: 'intencion_menor_5_palabras',
    puntos: 0,
    estado: 'sin_datos',
    detalle: 'Sin mensajes del lead para evaluar',
  }
}

function resolverVelocidad(prospecto = {}) {
  const origenScoring = resolverOrigenScoring(prospecto)
  if (origenDefaultAltaCompleto(prospecto)) {
    return {
      criterioId: 'velocidad_llenado_menor_igual_3_min',
      puntos: 20,
      estado: 'cumple',
      detalle: `Regla ${origenScoring.label}: por default llenado <= 3 min`,
    }
  }
  if (origenScoring.id === 'influencer') {
    return {
      criterioId: 'velocidad_llenado_mayor_3_min',
      puntos: 5,
      estado: 'cumple',
      detalle: 'Regla Influencer: se asume velocidad > 3 minutos',
    }
  }

  const terminoBot = esBotCompleto(prospecto)
  const minutos = prospecto.minutos_bot

  if (minutos !== null && minutos !== undefined && minutos !== '') {
    const minutosNum = Number(minutos)
    if (minutosNum <= 3) {
      return {
        criterioId: 'velocidad_llenado_menor_igual_3_min',
        puntos: 20,
        estado: 'cumple',
        detalle: `${minutosNum.toFixed(1)} min`,
      }
    }
    return {
      criterioId: 'velocidad_llenado_mayor_3_min',
      puntos: 5,
      estado: 'cumple',
      detalle: `${minutosNum.toFixed(1)} min`,
    }
  }

  if (!terminoBot) {
    return {
      criterioId: 'velocidad_llenado_mayor_3_min',
      puntos: 0,
      estado: 'sin_datos',
      detalle: 'No terminó el bot',
    }
  }

  if (minutos === null || minutos === undefined || minutos === '') {
    if (esBotCompleto(prospecto)) {
      return {
        criterioId: 'velocidad_llenado_menor_igual_3_min',
        puntos: 20,
        estado: 'cumple',
        detalle: 'Bot completo (tiempo no disponible)',
      }
    }
    return {
      criterioId: 'velocidad_llenado_mayor_3_min',
      puntos: 0,
      estado: 'sin_datos',
      detalle: 'Sin tiempo de llenado',
    }
  }

  const minutosNum = Number(minutos)
  if (minutosNum <= 3) {
    return {
      criterioId: 'velocidad_llenado_menor_igual_3_min',
      puntos: 20,
      estado: 'cumple',
      detalle: `${minutosNum.toFixed(1)} min`,
    }
  }

  return {
    criterioId: 'velocidad_llenado_mayor_3_min',
    puntos: 5,
    estado: 'cumple',
    detalle: `${minutosNum.toFixed(1)} min`,
  }
}

function resolverRecurrencia(prospecto = {}) {
  if (prospecto.es_usuario_anterior === true || prospecto.es_usuario_anterior === 1) {
    return {
      criterioId: 'recurrencia_usuario_anterior',
      puntos: 5,
      estado: 'cumple',
      detalle: 'Teléfono con prospecto previo',
    }
  }

  if (prospecto.es_usuario_anterior === false || prospecto.es_usuario_anterior === 0) {
    return {
      criterioId: 'recurrencia_usuario_nuevo',
      puntos: 15,
      estado: 'cumple',
      detalle: 'Primer contacto con este teléfono',
    }
  }

  return {
    criterioId: 'recurrencia_usuario_nuevo',
    puntos: 15,
    estado: 'sin_datos',
    detalle: 'Sin historial de teléfono',
  }
}

function resolverNivel(puntajeTotal) {
  if (puntajeTotal >= 130) {
    return NIVELES_CALIFICACION_LEADS.find((n) => n.slug === 'alta') || NIVELES_CALIFICACION_LEADS[2]
  }
  if (puntajeTotal >= 80) {
    return NIVELES_CALIFICACION_LEADS.find((n) => n.slug === 'media') || NIVELES_CALIFICACION_LEADS[1]
  }
  return NIVELES_CALIFICACION_LEADS.find((n) => n.slug === 'baja') || NIVELES_CALIFICACION_LEADS[0]
}

export function resolverIntentCategory(puntajeTotal) {
  return resolverNivel(puntajeTotal).intentCategory
}

/**
 * Infiere variables de calificación desde datos del prospecto.
 */
export function inferirVariablesDesdeProspecto(prospecto = {}) {
  const origen = resolverOrigenScoring(prospecto)
  let integridad = resolverIntegridad(prospecto, origen)
  let intencion = resolverIntencion(prospecto)
  let velocidad = resolverVelocidad(prospecto)
  const recurrencia = resolverRecurrencia(prospecto)

  if (integridad.criterioId === 'integridad_incompleto'
    && velocidad.criterioId === 'velocidad_llenado_menor_igual_3_min') {
    velocidad = {
      criterioId: 'velocidad_llenado_mayor_3_min',
      puntos: 5,
      estado: 'cumple',
      detalle: 'Regla matriz: con datos incompletos no aplica velocidad <= 3 min',
    }
  }

  return {
    origen,
    integridad,
    intencion,
    velocidad,
    recurrencia,
  }
}

/** Compatibilidad con código que usaba estados por criterio antiguo */
export function inferirCriteriosDesdeProspecto(prospecto = {}) {
  const vars = inferirVariablesDesdeProspecto(prospecto)
  const estados = {}

  SECCIONES_CALIFICACION_LEADS.forEach((seccion) => {
    const variable = vars[seccion.id]
    seccion.criterios.forEach((criterio) => {
      if (variable && criterio.id === variable.criterioId) {
        estados[criterio.id] = variable.estado
      } else {
        estados[criterio.id] = 'no_cumple'
      }
    })
  })

  return estados
}

export function estadosCriteriosABoolean(estados = {}) {
  const criterios = {}
  Object.keys(estados).forEach((id) => {
    criterios[id] = estados[id] === 'cumple'
  })
  return criterios
}

function construirDesgloseDesdeVariables(variables = {}) {
  return SECCIONES_CALIFICACION_LEADS.map((seccion) => {
    const variable = variables[seccion.id] || { puntos: 0, estado: 'sin_datos', criterioId: null }

    const criterios = seccion.criterios.map((criterio) => {
      const activo = criterio.id === variable.criterioId
      return {
        ...criterio,
        activo,
        estado: activo ? variable.estado : 'no_cumple',
        puntosObtenidos: activo ? variable.puntos : 0,
        detalle: activo ? variable.detalle : '',
      }
    })

    return {
      ...seccion,
      criterios,
      puntosObtenidos: variable.puntos || 0,
      detalle: variable.detalle || '',
    }
  })
}

export function calcularCalificacionLead(criteriosMarcados = {}, opciones = {}) {
  if (opciones.variables) {
    return calcularDesdeVariables(opciones.variables)
  }

  const desgloseSecciones = SECCIONES_CALIFICACION_LEADS.map((seccion) => {
    const criteriosActivos = seccion.criterios.filter((criterio) => criteriosMarcados[criterio.id])

    let criterioGanador = null
    if (seccion.exclusivo) {
      criterioGanador = criteriosActivos.sort((a, b) => b.puntos - a.puntos)[0] || null
    } else {
      criterioGanador = criteriosActivos[0] || null
    }

    const criterios = seccion.criterios.map((criterio) => {
      const activo = criterioGanador ? criterio.id === criterioGanador.id : false
      return {
        ...criterio,
        activo,
        estado: activo ? 'cumple' : 'no_cumple',
        puntosObtenidos: activo ? criterio.puntos : 0,
      }
    })

    const puntosSeccion = criterioGanador ? criterioGanador.puntos : 0

    return {
      ...seccion,
      criterios,
      puntosObtenidos: puntosSeccion,
    }
  })

  return armarResultado(desgloseSecciones)
}

function calcularDesdeVariables(variables) {
  const desgloseSecciones = construirDesgloseDesdeVariables(variables)
  return armarResultado(desgloseSecciones, variables)
}

function armarResultado(desgloseSecciones, variables = {}) {
  const puntajeBase = desgloseSecciones.reduce((suma, s) => suma + s.puntosObtenidos, 0)
  const origenId = variables.origen ? variables.origen.id : 'desconocido'
  const integridadFlag = variables.integridad && variables.integridad.criterioId === 'integridad_completo' ? 1 : 0
  const intencionFlag = variables.intencion && variables.intencion.criterioId === 'intencion_5_palabras' ? 1 : 0
  const velocidadFlag = variables.velocidad && variables.velocidad.criterioId === 'velocidad_llenado_menor_igual_3_min' ? 1 : 0
  const recurrenciaFlag = variables.recurrencia && variables.recurrencia.criterioId === 'recurrencia_usuario_nuevo' ? 1 : 0
  const combo = normalizarComboTablaVerdad(integridadFlag, intencionFlag, velocidadFlag)
  const origenCatalogo = ORIGENES_CALIFICACION_CATALOGO.find((o) => o.id === origenId)
  const puntajeOficial = origenCatalogo
    ? puntajeEsperadoPorCaso(
      origenCatalogo,
      combo.integridad,
      combo.intencion,
      combo.velocidad,
      recurrenciaFlag
    )
    : null
  const puntajeBruto = puntajeBase
  const puntajeTotal = puntajeOficial != null ? puntajeOficial : puntajeBase
  const nivel = resolverNivel(puntajeTotal)
  const intentCategory = nivel.intentCategory

  const porcentaje = PUNTAJE_MAXIMO_LEAD
    ? Math.round((puntajeTotal / PUNTAJE_MAXIMO_LEAD) * 100)
    : 0

  const variablesEvaluables = desgloseSecciones.filter((s) =>
    s.criterios.some((c) => c.activo && c.estado !== 'sin_datos')
  ).length
  const variablesSinDatos = desgloseSecciones.filter((s) =>
    s.criterios.every((c) => !c.activo || c.estado === 'sin_datos')
  ).length

  return {
    puntajeTotal,
    puntajeBruto,
    intentCategory,
    puntajeMaximo: PUNTAJE_MAXIMO_LEAD,
    porcentaje,
    nivel,
    desgloseSecciones,
    criteriosActivos: desgloseSecciones.filter((s) => s.puntosObtenidos > 0).length,
    criteriosTotales: desgloseSecciones.length,
    criteriosEvaluables: variablesEvaluables,
    criteriosSinDatos: variablesSinDatos,
    completitudDatos: Math.round((variablesEvaluables / desgloseSecciones.length) * 100),
  }
}

export function calcularCalificacionDesdeProspecto(prospecto = {}) {
  const variables = inferirVariablesDesdeProspecto(prospecto)
  const origen = resolverOrigenProspecto(prospecto)
  const resultado = calcularCalificacionLead({}, { variables })
  const integridadFlag = variables.integridad && variables.integridad.criterioId === 'integridad_completo' ? 1 : 0
  const intencionFlag = variables.intencion && variables.intencion.criterioId === 'intencion_5_palabras' ? 1 : 0
  const velocidadFlag = variables.velocidad && variables.velocidad.criterioId === 'velocidad_llenado_menor_igual_3_min' ? 1 : 0
  const recurrenciaFlag = variables.recurrencia && variables.recurrencia.criterioId === 'recurrencia_usuario_nuevo' ? 1 : 0
  const folioCaso = resolverCasoTablaVerdad(
    variables.origen.id,
    integridadFlag,
    intencionFlag,
    velocidadFlag,
    recurrenciaFlag
  )

  return {
    ...resultado,
    variables,
    estadosCriterio: inferirCriteriosDesdeProspecto(prospecto),
    origen,
    origenLabel: variables.origen.label,
    origenScoringId: variables.origen.id,
    botCompleto: esBotCompleto(prospecto),
    folio_caso: folioCaso,
  }
}

export const STORAGE_KEY_PUNTAJES_CALIFICACION = 'calificacion_leads_puntajes_config_v1'

export function crearConfigPuntajesEditable() {
  const criterios = {}
  SECCIONES_CALIFICACION_LEADS.forEach((seccion) => {
    seccion.criterios.forEach((c) => {
      criterios[c.id] = c.puntos
    })
  })
  const origenes = {}
  ORIGENES_CALIFICACION_CATALOGO.forEach((o) => {
    origenes[o.id] = o.puntos
  })
  return {
    criterios: { ...criterios },
    origenes: { ...origenes },
    flags: JSON.parse(JSON.stringify(PUNTOS_OFICIALES_POR_FLAG)),
    bonus: { ...BONUS_PUNTAJE_POR_COMBO },
  }
}

export function mergeConfigPuntajes(guardado) {
  const base = crearConfigPuntajesEditable()
  if (!guardado || typeof guardado !== 'object') return base
  return {
    criterios: { ...base.criterios, ...(guardado.criterios || {}) },
    origenes: { ...base.origenes, ...(guardado.origenes || {}) },
    flags: {
      integridad: { ...base.flags.integridad, ...((guardado.flags && guardado.flags.integridad) || {}) },
      intencion: { ...base.flags.intencion, ...((guardado.flags && guardado.flags.intencion) || {}) },
      velocidad: { ...base.flags.velocidad, ...((guardado.flags && guardado.flags.velocidad) || {}) },
      recurrencia: { ...base.flags.recurrencia, ...((guardado.flags && guardado.flags.recurrencia) || {}) },
    },
    bonus: { ...base.bonus, ...(guardado.bonus || {}) },
  }
}

export function cargarConfigPuntajesDesdeStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PUNTAJES_CALIFICACION)
    if (!raw) return crearConfigPuntajesEditable()
    return mergeConfigPuntajes(JSON.parse(raw))
  } catch (_) {
    return crearConfigPuntajesEditable()
  }
}

export function guardarConfigPuntajesEnStorage(config) {
  localStorage.setItem(STORAGE_KEY_PUNTAJES_CALIFICACION, JSON.stringify(config))
}

export function cargarConfigPuntajesDesdeApi(http) {
  return http.get('prospectos.calificacion.leads.puntajes').then((response) => {
    const data = response.data || {}
    return {
      config: mergeConfigPuntajes(data.config),
      filas: data.filas || [],
      updated_at: data.updated_at || null,
      updated_by: data.updated_by || null,
    }
  })
}

export function guardarConfigPuntajesEnApi(http, payload = {}) {
  return http.post('prospectos.calificacion.leads.puntajes', payload).then((response) => {
    const data = response.data || {}
    return {
      config: mergeConfigPuntajes(data.config),
      filas: data.filas || [],
      updated_at: data.updated_at || null,
      updated_by: data.updated_by || null,
      message: data.message || 'Puntajes guardados',
    }
  })
}

export function puntosOficialesPorFlagConConfig(seccion, flag, config) {
  const tabla = (config && config.flags && config.flags[seccion]) || PUNTOS_OFICIALES_POR_FLAG[seccion]
  if (!tabla) return 0
  return tabla[flag ? 1 : 0]
}

export function filasEditablePuntajes(config = crearConfigPuntajesEditable()) {
  const filas = []
  ORIGENES_CALIFICACION_CATALOGO.forEach((o) => {
    filas.push({
      grupo: 'Origen',
      id: o.id,
      criterioId: `origen_${o.id}`,
      etiqueta: o.label,
      puntos: Number(config.origenes[o.id] != null ? config.origenes[o.id] : o.puntos),
      tipo: 'origen',
    })
  })
  SECCIONES_CALIFICACION_LEADS.filter((s) => s.id !== 'origen').forEach((seccion) => {
    seccion.criterios.forEach((c) => {
      filas.push({
        grupo: seccion.titulo,
        id: c.id,
        criterioId: c.id,
        etiqueta: c.etiqueta,
        puntos: Number(config.criterios[c.id] != null ? config.criterios[c.id] : c.puntos),
        tipo: 'criterio',
        seccionId: seccion.id,
      })
    })
  })
  return filas
}

export function resolverDesglosePuntosConConfig(prospecto = {}, config = null) {
  if (!config) return resolverDesglosePuntosOficialDesdeProspecto(prospecto)

  const combo = extraerComboDesdeProspecto(prospecto)
  if (!combo || !combo.origenId) return null

  const origenCatalogo = ORIGENES_CALIFICACION_CATALOGO.find((o) => o.id === combo.origenId)
  const origenPts = Number(
    config.origenes[combo.origenId] != null
      ? config.origenes[combo.origenId]
      : (origenCatalogo ? origenCatalogo.puntos : 0)
  )
  const integridad = puntosOficialesPorFlagConConfig('integridad', combo.integridad, config)
  const intencion = puntosOficialesPorFlagConConfig('intencion', combo.intencion, config)
  const velocidad = puntosOficialesPorFlagConConfig('velocidad', combo.velocidad, config)
  const recurrencia = puntosOficialesPorFlagConConfig('recurrencia', combo.recurrencia, config)
  const total = origenPts + integridad + intencion + velocidad + recurrencia
  const origenLabel = origenCatalogo ? origenCatalogo.label : combo.origenId
  const partes = { origen: origenPts, integridad, intencion, velocidad, recurrencia }

  const fmt = (flag, campo) =>
    formatearFlagMatrizConPuntos(flag, puntosOficialesPorFlagConConfig(campo, flag, config))

  return {
    combo,
    origen: origenPts,
    origenLabel,
    integridad,
    intencion,
    velocidad,
    recurrencia,
    bonus: 0,
    total,
    origenTexto: `${origenLabel} (${origenPts})`,
    integridadTexto: fmt(combo.integridad, 'integridad'),
    intencionTexto: fmt(combo.intencion, 'intencion'),
    velocidadTexto: fmt(combo.velocidad, 'velocidad'),
    recurrenciaTexto: fmt(combo.recurrencia, 'recurrencia'),
    desgloseSuma: formatearDesgloseSumaPuntos(partes, 0, total),
  }
}

export function resolverPuntajeConConfig(prospecto = {}, config = null) {
  const desglose = resolverDesglosePuntosConConfig(prospecto, config)
  return desglose ? desglose.total : null
}

export function sincronizarConfigDesdeFilas(config, filas = []) {
  const next = {
    criterios: { ...config.criterios },
    origenes: { ...config.origenes },
    flags: JSON.parse(JSON.stringify(config.flags)),
    bonus: { ...config.bonus },
  }
  filas.forEach((fila) => {
    const pts = Math.max(0, Number(fila.puntos) || 0)
    if (fila.tipo === 'origen') {
      next.origenes[fila.id] = pts
      next.criterios[`origen_${fila.id}`] = pts
      return
    }
    next.criterios[fila.criterioId] = pts
    if (fila.seccionId && fila.seccionId !== 'origen') {
      const flag = fila.criterioId.includes('_5_palabras')
        || fila.criterioId.includes('completo')
        || fila.criterioId.includes('menor_igual_3')
        || fila.criterioId.includes('usuario_nuevo')
        ? 1
        : 0
      if (next.flags[fila.seccionId]) next.flags[fila.seccionId][flag] = pts
    }
  })
  return next
}
